module.exports = __webpack_public_path__ + "img/kommune-912.8e0eb351.svg";